export default "__VITE_ASSET__e406fbc9__"